class ICoreMarqueeScroller {
    elementId = null;
    marqueeContainer = null;

    constructor(elementId) {
        this.elementId = elementId;
        this.marqueeInstance = null;

        this.init();
    }

    init() {
        this.marqueeContainer = document.getElementById(this.elementId);
        if ( !this.marqueeContainer ) {
            return new Error('No marquee container element found');
        }

        if ( window.matchMedia("(prefers-reduced-motion: reduce)").matches ) {
            if ( this.marqueeContainer.classList.contains('izzycart-marquee-scroller--fadeEdges') ) {
                this.marqueeContainer.classList.remove('izzycart-marquee-scroller--fadeEdges');
            }

            this.revealWithoutAnimation();
            return;
        }

        this.addAnimation();
    }

    revealWithoutAnimation() {
        const scrollerInner = this.marqueeContainer.querySelector('.izzycart-marquee-scroller__inner');

        this.marqueeContainer.classList.remove('is--marquee-pending');
        this.marqueeContainer.setAttribute('data-animated', 'true');

        if ( scrollerInner ) {
            scrollerInner.style.opacity = '1';
        }
    }

    addAnimation = () => {
        const scrollerInner = this.marqueeContainer.querySelector('.izzycart-marquee-scroller__inner');

        if ( !scrollerInner ) {
            return;
        }

        const originals = Array.from(scrollerInner.children).filter(
            (node) => !node.classList.contains('icore-marquee-clone')
        );

        if ( !originals.length ) {
            return;
        }

        this.showClones(scrollerInner);

        if ( !scrollerInner.querySelector('.icore-marquee-clone') ) {
            originals.forEach((item) => {
                const dupItem = item.cloneNode(true);
                dupItem.setAttribute('aria-hidden', 'true');
                dupItem.classList.add('icore-marquee-clone');
                scrollerInner.appendChild(dupItem);
            });
        }

        this.startAnimation(scrollerInner);
    };

    showClones(scrollerInner) {
        scrollerInner.querySelectorAll('.icore-marquee-clone').forEach((clone) => {
            clone.style.removeProperty('display');
        });
    }

    startAnimation(scrollerInner) {
        const firstClone = scrollerInner.querySelector('.icore-marquee-clone');

        const enable = () => {
            if ( firstClone ) {
                const distance = firstClone.offsetLeft;

                if ( distance > 0 ) {
                    scrollerInner.style.setProperty('--icore-marquee-scroll-distance', `-${distance}px`);
                }
            }

            this.marqueeContainer.classList.remove('is--marquee-pending');
            this.marqueeContainer.setAttribute('data-animated', 'true');
        };

        requestAnimationFrame(() => {
            requestAnimationFrame(enable);
        });
    }

    // Not used currently but can be useful for future features
    addHoverEvents = () => {
        this.marqueeContainer.addEventListener('mouseenter', this.pauseAnimation);
        this.marqueeContainer.addEventListener('mouseleave', this.resumeAnimation);
    }
}

export default ICoreMarqueeScroller;
